module.exports = require("halosee-ui/src/locale/lang/zh-CN");